import React, { useState, useEffect, useRef, Fragment } from 'react';

type Props = {
  text: string; // Input text to be displayed word by word
//   setNewMessage: React.Dispatch<React.SetStateAction<boolean>>;
}

function WordByWordDisplay({ text }: Props) {
  const [displayedText, setDisplayedText] = useState<string>(''); // State for displayed text
  const [currentIndex, setCurrentIndex] = useState<number>(0); // State for the current word index
  const words: string[] = text.split(' '); // Split the input text into words
  const containerRef = useRef<HTMLSpanElement>(null); // Ref for scroll behavior

  useEffect(() => {
    if (currentIndex < words.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + words[currentIndex] + ' ');
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, 100); // 100ms delay between words

      // Cleanup timeout to prevent memory leaks
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, words]);

  useEffect(() => {
    // Scroll to the bottom when text updates
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [displayedText]);

  return (
    <span ref={containerRef} style={{display:'inline-block',width:'100%'}}> 
	{
		displayedText.split("\n").map((line, indx) => (
			<Fragment key={indx}>
				{line}
				<br />
			</Fragment>
		))
	}
	</span>
  );
};

export default WordByWordDisplay;
